import { render, staticRenderFns } from "./businessdata.vue?vue&type=template&id=356e15b3&scoped=true"
import script from "./businessdata.vue?vue&type=script&lang=js"
export * from "./businessdata.vue?vue&type=script&lang=js"
import style0 from "./businessdata.vue?vue&type=style&index=0&id=356e15b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e15b3",
  null
  
)

export default component.exports